import fileMediaVideoPlayer from './file-media-video-player';
export default fileMediaVideoPlayer;
